module.exports = __webpack_public_path__ + "img/system-2.bc5f4a1d.png";